/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import checkout from 'layouts/user-management/components/schemas/form';

const {
  formField: { firstName, lastName, email, role, password, repeatPassword, clientId, operatorId, brandId }
} = checkout;
const initialValues = {
  [firstName.name]: '',
  [lastName.name]: '',
  [email.name]: '',
  [role.name]: '',
  [password.name]: '',
  [repeatPassword.name]: '',
  [clientId.name]: '',
  [operatorId.name]: '',
  [brandId.name]: ''
};

export default initialValues;
